import './Project.css';
import projectData from './Project-data';
import Projectdisp from './Project-disp';
import { useRef, useEffect, useState, useCallback } from 'react';
import { dailyJournal, marvelPedia, adminDash, groco, laptopFrame, travelPartner } from './../../Assets/Project-photos/Photo';

export default function Project() {
    const [projectVisible, setProjectVisible] = useState();
    const [index, setIndex] = useState(0);

    const photoArray = [dailyJournal, travelPartner, marvelPedia, adminDash, groco];

    const projectRef = useRef();
    const slideRef = useRef();
    const indexRef = useRef(0);

    const nextIndex = useCallback(() => {
        setIndex(prev => {
            const next = prev + 1 === photoArray.length ? 0 : prev + 1;
            indexRef.current = next;
            return next;
        });
    }, [photoArray.length]);

    const prevIndex = useCallback(() => {
        setIndex(prev => {
            const next = prev - 1 < 0 ? photoArray.length - 1 : prev - 1;
            indexRef.current = next;
            return next;
        });
    }, [photoArray.length]);

    useEffect(() => {
        const currentRef = projectRef.current;
        const observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            if (entry.isIntersecting === true) {
                setProjectVisible(true);
            }
        });
        observer.observe(currentRef);

        const interval = setInterval(() => nextIndex(), 3000);
        return () => {
            clearInterval(interval);
            observer.unobserve(currentRef);
        };
    }, [nextIndex]);

    return (
        <div ref={projectRef} className='project' id='projects'>
            <div className={`heading reveal-left ${projectVisible ? "animate" : ""}`}>
                Each <span>project</span> is a unique piece of developement.
            </div>
            <div className={`frame-wrapper reveal-bottom ${projectVisible ? "animate" : ""}`}>
                <img src={laptopFrame} alt="frame" id="laptop-frame" />
                <div className="project-img-cont">
                    <IconLeftArrow onClick={prevIndex} className="arrow left" />
                    <IconRightArrow onClick={nextIndex} className="arrow right" />
                    <div ref={slideRef}>
                        <img src={photoArray[index]} alt="img" />
                    </div>
                </div>
            </div>

            <div className={`reveal-bottom ${projectVisible ? "animate" : ""}`}>
                {projectData.map((element, index) =>
                    index < 3 && <Projectdisp
                        key={element.head}
                        image={element.image}
                        viewLink={element.viewLink}
                        codeLink={element.codeLink}
                        head={element.head}
                        text={element.text}
                        skills={element.skills}
                    />)}
            </div>
            <div className='more-project-link'>
                <a href="/work">
                    View more projects <IconRightArrow />
                </a>
            </div>
        </div>
    );
}

function IconRightArrow(props) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M5.536 21.886a1.004 1.004 0 001.033-.064l13-9a1 1 0 000-1.644l-13-9A1 1 0 005 3v18a1 1 0 00.536.886z" />
        </svg>
    );
}
function IconLeftArrow(props) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            height="1em"
            width="1em"
            {...props}
        >
            <path d="M4.431 12.822l13 9A1 1 0 0019 21V3a1 1 0 00-1.569-.823l-13 9a1.003 1.003 0 000 1.645z" />
        </svg>
    );
}